// Headers for the Page-level tables
// Be sure to order them as they should appear on page

export const LEAD_HEADERS = [
  {'Submitted At': 'created_at', 'classes': 'th-fixed-width-sm'},
  {'Name (DBA)': 'dba', 'classes': 'th-fixed-width-lg'},
  {'Opportunity Status': 'status', 'classes': 'th-fixed-width-sm'}
];

export const LEAD_VALUES = [
  {'created_at': 'created_at'},
  {'dba': 'dba'},
  {'status': 'status'}
];

export const LEAD_VALUES_FOR_DATA_LABELS = [
  {'created_at': 'Created At'},
  {'dba': 'Name (DBA)'},
  {'status': 'Status' }
];

export const HOMEPAGE_PIPELINE_HEADERS = [
  {'Date Received': null, 'classes': 'th-fixed-width-md'},
  {'Name (DBA)': 'dba', 'classes': 'th-fixed-width-lg'},
  {'Type': 'new_or_renewal', 'classes': 'th-fixed-width-xs'},
  {'Action': null, 'classes': 'th-fixed-width-sm'}
];

export const HOMEPAGE_PIPELINE_VALUES = [
  {'date_received': 'date_received'},
  {'dba': 'dba'},
  {'new_or_renewal': 'new_or_renewal'},
  {'calculator_url': 'calculator_url'}
];

export const HOMEPAGE_PIPELINE_VALUES_FOR_DATA_LABELS = [
  {'date_received': 'Date Received'},
  {'dba': 'Name (DBA)'},
  {'new_or_renewal': 'Type'},
  {'calculator_url': 'Action'}
];

export const PIPELINE_HEADERS = [
  {'Date Received': null, 'classes': 'th-fixed-width-md'},
  {'Name (DBA)': null, 'classes': 'th-fixed-width-lg'},
  {'Type': null, 'classes': 'th-fixed-width-xs'},
  {'Stage': null, 'classes': 'th-fixed-width-md'},
  {'Action': null, 'classes': 'th-fixed-width-sm'}
];

export const PIPELINE_VALUES = [
  {'date_received': 'date_received'},
  {'dba': 'dba'},
  {'new_or_renewal': 'new_or_renewal'},
  {'stage': 'stage'},
  {'calculator_url': 'calculator_url'}
];

export const PIPELINE_VALUES_FOR_DATA_LABELS = [
  {'date_received': 'Date Received'},
  {'dba': 'Name (DBA)'},
  {'new_or_renewal': 'Type'},
  {'stage': 'Stage'},
  {'calculator_url': 'Action'}
];

export const PORTFOLIO_HEADERS = [
  {
    "Advance Date": "funded_advance_query_date",
  },
  { "Business DBA": null, classes: "th-percent-width-lg" },
  { Amount: null, classes: "th-percent-width-sm" },
  { Outstanding: null },
  { "%\xa0Repaid": null, classes: "th-percent-width-sm" },
  {
    "Last Payment Date": "funded_advance_last_payment_date_unix",
  },
  { "Program Name": null },
  { "Renewal Status": null },
];

export const PORTFOLIO_VALUES = [
  {'advance_date': 'advance_date'},
  {'dba': 'dba'},
  {'advance_amount': 'advance_amount'},
  {'balance_outstanding': 'balance_outstanding'},
  {'percentage_repaid_partners_format': 'percentage_repaid'},
  {'last_payment_date_partners_format': 'last_payment_date'},
  {'program_name': 'program_name'},
  {'renewal_eligibility': 'renewal_eligibility'}
];

export const PORTFOLIO_VALUES_FOR_DATA_LABELS = [
  {'advance_date': 'Advance Date'},
  {'dba': 'Business DBA'},
  {'advance_amount': 'Advance Amount'},
  {'balance_outstanding': 'Outstanding'},
  {'percentage_repaid_partners_format': '% Repaid'},
  {'last_payment_date_partners_format': 'Last Payment Date'},
  {'program_name': 'Program Name'},
  {'renewal_eligibility': 'Renewal Status'}
];
